// extracted by mini-css-extract-plugin
export var alternate = "_1g-j";
export var black = "_1g-6";
export var blue = "_1g-f";
export var blueLight = "_1g-e";
export var brand = "_1g-8";
export var darkMode = "_1g-b";
export var error = "_1g-a";
export var gray = "_1g-5";
export var grayBlue = "_1g-d";
export var iconWrapper = "_1g-3";
export var inactive = "_1g-7";
export var indigo = "_1g-g";
export var orange = "_1g-i";
export var pink = "_1g-h";
export var primary = "_1g-0";
export var purple = "_1g-9";
export var success = "_1g-4";
export var warning = "_1g-c";
export var white = "_1g-1";
export var whiteSuccess = "_1g-2";